import React, { forwardRef } from 'react';
import { InfoIcon } from 'lucide-react';
import { Tooltip } from './Tooltip';
interface TextareaProps extends React.TextareaHTMLAttributes<HTMLTextAreaElement> {
  label?: string;
  error?: string;
  helperText?: string;
  infoTooltip?: string;
}
export const Textarea = forwardRef<HTMLTextAreaElement, TextareaProps>(({
  label,
  error,
  helperText,
  infoTooltip,
  className = '',
  ...props
}, ref) => {
  return <div className="w-full" data-id="element-618">
        {label && <div className="flex items-center mb-2" data-id="element-619">
            <label className="block text-sm font-semibold text-gray-900" data-id="element-620">
              {label}
            </label>
            {infoTooltip && <Tooltip content={infoTooltip} data-id="element-621">
                <button type="button" className="ml-2 text-gray-400 hover:text-[#007AFF] focus:outline-none" data-id="element-622">
                  <InfoIcon className="w-4 h-4" data-id="element-623" />
                </button>
              </Tooltip>}
          </div>}
        <textarea ref={ref} className={`w-full px-4 py-3 bg-white border-2 rounded-xl outline-none transition-all duration-200 text-gray-900 placeholder-gray-400 min-h-[120px] resize-y
            ${error ? 'border-red-300 focus:border-red-500 focus:ring-2 focus:ring-red-200' : 'border-gray-200 focus:border-[#007AFF] focus:ring-2 focus:ring-[#E6F2FF] hover:border-gray-300'} ${className}`} {...props} data-id="element-624" />
        {error && <p className="mt-2 text-sm text-red-500" data-id="element-625">{error}</p>}
        {helperText && !error && <p className="mt-2 text-sm text-gray-500" data-id="element-626">{helperText}</p>}
      </div>;
});
Textarea.displayName = 'Textarea';